import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Tmd.dtos';

import {
    ACTION_TRIALINSTITUTIONITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE,
    ACTION_TRIALINSTITUTIONITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE
} from '../../actions/pages/trialInstitutionItemsPage';


export interface ITrialInstitutionItemsPageState {
    editModalOpen: boolean;
    collectionInstanceId: number;
    name: string;
    description: string;
    createVersionModalOpen: boolean;
    trialInstitutionItem: Dtos.TrialInstitutionItem
}

const initialState: ITrialInstitutionItemsPageState = {
    editModalOpen: false,
    collectionInstanceId: null,
    name: "",
    description: "",
    createVersionModalOpen: false,
    trialInstitutionItem: null
};


function setEditModalViewState(state: ITrialInstitutionItemsPageState, open: boolean, collectionInstanceId: number, name: string, description: string): ITrialInstitutionItemsPageState {
    const newState: ITrialInstitutionItemsPageState = update(state, {
        editModalOpen: {
            $set: open
        },
        collectionInstanceId: {
            $set: collectionInstanceId
        },
        name: {
            $set: name
        },
        description: {
            $set: description
        }
    });
    return newState;
}

function setCreateVersionModalViewState(state: ITrialInstitutionItemsPageState, open: boolean, trialInstitutionItem: Dtos.TrialInstitutionItem): ITrialInstitutionItemsPageState {
    const newState: ITrialInstitutionItemsPageState = update(state, {
        createVersionModalOpen: {
            $set: open
        },
        trialInstitutionItem: {
            $set: trialInstitutionItem
        }
    });
    return newState;
}

const TrialInstitutionItemsPageReducer: Reducer<ITrialInstitutionItemsPageState> = (state: ITrialInstitutionItemsPageState = initialState, action) => { 
    switch (action.type) {
        case ACTION_TRIALINSTITUTIONITEMS_PAGE_SET_EDIT_MODAL_VIEW_STATE:
            return setEditModalViewState(state, action.open, action.collectionInstanceId, action.name, action.description);
        case ACTION_TRIALINSTITUTIONITEMS_PAGE_SET_CREATEVERSION_MODAL_VIEW_STATE:
            return setCreateVersionModalViewState(state, action.open, action.trialInstitutionItem);
    }

    return state;
}

export default TrialInstitutionItemsPageReducer;